import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { createColumnHelper } from "@tanstack/react-table"
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient"
import DataTable from "../../../components/dataTable/DataTable"
import { iDespesaClienteDto } from "../dto/despesas_clientes"

const columnHelper = createColumnHelper<iDespesaClienteDto>()

const defaultColumns = [
    columnHelper.accessor('id_cliente', {
        header: 'Cod. Cliente',
        size: 10,
    }),
    columnHelper.accessor('descricao', {
        header: 'Descrição',
        size: 300,
    }),
    columnHelper.accessor('id_centro_custo', {
        header: 'Cod. Centro Custo',
        size: 10,
    }),
    columnHelper.accessor(row => `${row.ativo === 1 ? `Ativo` : `Desativado`}`, {
        header: 'Status',
        size: 30,
    }),
]

const defaultOrder:any = []

function DespesasClientesPage() {
    const [clientes, setClientes] = useState<iDespesaClienteDto[]>([])

    useEffect(() => {
        document.title = "Despesas Clientes | OB PORTUS"

        listarDados()
    }, [])

    async function listarDados() {
        const api = await reqGetNew(ApiEndpoints.despesasClientes)

        if (api.status === 200) {
            const clientesAux:iDespesaClienteDto[] = api.data
            setClientes(clientesAux)
        }
    }

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = clientes[idx]
        const link = `/despesa/cliente/editar?id=${reg.id_cliente}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = clientes[idx]
        const link = `/despesa/cliente/editar?id=${reg.id_cliente}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <h1 id="titleMain">Despesas Clientes</h1>
                <div className="div-row">
                    <Button onClick={() => {
                        window.location.assign(`/despesa/cliente/cadastrar`)
                    }}>Cadastrar</Button>
                </div>
            </div>
            <br></br>
            {<DataTable dados={clientes} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />}
        </div>
    )
}

export default DespesasClientesPage